export const splitNumber = (n: number) => {
  let lang;
  if (typeof window !== 'undefined' && typeof window.config === 'object') {
    lang = window.config?.LANGUAGE;
  }

  // console.log('[DEBUG] LANGUAGE IN SPLIT NUMBER', lang);

  if (lang?.toLowerCase() === 'es') {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
